// rdar://83584636 (P2: Music Issue: Unintended Korean localization "및" appearing in artist listing in production,  Music (desktop only))
const DEVIATING_DELIMITER_LANGUAGES = ['ar', 'ko'];
const TEXT = 'TEXT';

/**
 * Returns a list of list localized delimiters for a given amount of items.
 *
 * Exceptions: For some non-English alphabet rtl languages, it can still have English text, like artist names.
 * Would be weird to use the user language delimiter, so check the first item to indicate if it's English.
 */

export function getListDelimiters(
    items: string[],
    locale: string,
    translateFn: (s: string) => string,
): string[] {
    if (items.length <= 1) return [];

    const isDeviatingLanguage = DEVIATING_DELIMITER_LANGUAGES.some(
        (languageCode) => locale.startsWith(languageCode),
    );

    // If it's a deviating language and the first list item is in English characters, use default delimiters
    if (isDeviatingLanguage && /[a-zA-Z0-9]/.test(items[0])) {
        return _getDelimiters(items.length, 'en', ', ');
    }
    return _getDelimiters(
        items.length,
        locale,
        translateFn('FUSE.Common.ListDelimiter'),
    );
}

export function separatedList(
    items: string[],
    locale: string,
    translateFn: (s: string) => string,
): string {
    const delimiters = getListDelimiters(items, locale, translateFn);
    return items
        .map((item, index) => item + (delimiters[index] || ''))
        .join('');
}

function _getDelimiters(
    listLength: number,
    language: string,
    defaultDelimiter: string,
) {
    //  Intl.ListFormat is not supported on Safari <14.1, so use hardcoded or translated delimiter instead.
    //  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/ListFormat#browser_compatibility
    if (!Intl || !Intl.ListFormat || typeof Intl.ListFormat !== 'function') {
        return new Array(listLength - 1).fill(defaultDelimiter);
    }

    // Fill an array with the same lenth with dummy text to easily split
    const dummyArray = new Array(listLength).fill(TEXT);
    // Format the dummy array and only get the delimiters between dummy text
    return new Intl.ListFormat(language, { style: 'short' })
        .format(dummyArray)
        .split(TEXT)
        .slice(1, -1);
}
